import React from 'react';
import PropTypes from 'prop-types';

import OnDeleteIcon from '../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../icons/OnEditIcon';

import card from '../../../commonStyles/card.module.css';

const JobGoalCard = ({
    jobGoal,
    isDisabled = false,
    onEditJobGoal,
    onDeleteJobGoal
}) => {

    return (
        <div className={card.card} data-testid="job_goal_card">
            <div className={`${card.banner}`}>
                <h6>Job Goal</h6>
                {!isDisabled && (
                    <div className={card.bannerActions}>
                        <span className={card.editIcons} data-testid="job_goals_card_icons">
                            <OnEditIcon
                                onEdit={() => onEditJobGoal(jobGoal)}
                                active={!isDisabled}
                            />
                            <OnDeleteIcon
                                onDelete={() => onDeleteJobGoal(jobGoal)}
                                active={!isDisabled}
                            />
                        </span>
                    </div>
                )}
            </div>
            <div className={card.content}>
                <div className={card.section}>
                    <p>
                        <span>Job Sector: </span>
                        {jobGoal.sector}
                    </p>
                    <p>
                        <span>Job Title: </span>
                        {jobGoal.title}
                    </p>
                </div>
            </div>
        </div>
    );
};

JobGoalCard.propTypes = {
    jobGoal: PropTypes.object,
    isDisabled: PropTypes.bool,
    onEditJobGoal: PropTypes.func,
    onDeleteJobGoal: PropTypes.func
};

export default JobGoalCard;
